import React from 'react';
import { styled } from 'styled-components';
import { SuggestionStatus } from '@dazzle/api-client';

import { DeviceQueries } from 'Common/components/styled';
import { useSuggestionsContext } from 'Compass/contexts/SuggestionsContext';

const FilterableStatuses = [
  SuggestionStatus.PendingReview, SuggestionStatus.Pending, SuggestionStatus.Dismissed
];

const SuggestionStatusNames = {
  [SuggestionStatus.PendingReview]: 'Pending Review',
  [SuggestionStatus.Pending]: 'Approved',
  [SuggestionStatus.Dismissed]: 'Dismissed',
};

const SuggestionFilters = () => {
  const suggestionsContext = useSuggestionsContext();

  return <FilterBar>
    <FilterGroup>
      {
        Object.values(FilterableStatuses).map(suggestionStatus => <FilterText
          key={suggestionStatus}
          $active={suggestionsContext.suggestionStatusFilter === suggestionStatus}
          onClick={() => suggestionsContext.setSuggestionTypeFilter(suggestionStatus)}
        >
          {SuggestionStatusNames[suggestionStatus]}
        </FilterText>)
      }
    </FilterGroup>
  </FilterBar>
};

const FilterBar = styled.div`
  display: flex;
  gap: 12px;
  background: #F8F9FC;
  padding: 14px 20px;
  border: 1px solid #E4E7EF;
  border-radius: 12px;
  margin-bottom: 16px;

  @media (${DeviceQueries.mobile}) {
    flex-direction: column;
  }
`;

const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FilterText = styled.div<{$active: boolean}>`
  font-size: 13px;
  padding: 5px 12px;
  border-radius: 8px;
  transition: all 0.15s ease;
  ${({$active}) => $active
    ? 'font-weight: 600; color: #008AFF; background: rgba(0, 138, 255, 0.08);'
    : 'cursor: pointer; color: #5A6178; &:hover { color: #1A1D2B; background: rgba(0, 0, 0, 0.03); }'}
`;

export default SuggestionFilters;
